import lf from 'lovefield';

import moment from 'moment';

//db
export let thanksLogDB;

const dbName = 'thanksLogDB';
const version = 201901141936;

const schemaBuilder = lf.schema.create(dbName, version);

export const tableNames = {
    members:'Members',
    thanks:'Thanks'
}

schemaBuilder.createTable(tableNames.members)
    .addColumn('id', lf.Type.INTEGER)
    .addColumn('name', lf.Type.STRING)
    .addColumn('memo', lf.Type.STRING)
    .addColumn('head', lf.Type.STRING)
    .addColumn('eyes', lf.Type.STRING)
    .addColumn('eyeblows', lf.Type.STRING)
    .addColumn('mouth', lf.Type.STRING)
    .addColumn('face_ex', lf.Type.STRING)
    .addColumn('color', lf.Type.STRING)
    .addColumn('order', lf.Type.INTEGER)
    .addColumn('twitter_id',lf.Type.STRING)
    .addPrimaryKey(['id'],true)
    .addNullable(['order']);


//member_idはnullでも良い。
//member_idが存在しないものだったら、誰でもないメンバーとしてnullのまま扱う
//なので、外部キーでなくて良い。memberが消えてもthanksは残る。or消すか選べる。
//日付に関しても、いつでもないものも受け付ける。
schemaBuilder.createTable(tableNames.thanks)
    .addColumn('id', lf.Type.INTEGER)
    .addColumn('title', lf.Type.STRING)
    .addColumn('member_id', lf.Type.INTEGER)
    .addColumn('date', lf.Type.STRING)
    .addColumn('memo', lf.Type.STRING)
    .addColumn('check', lf.Type.BOOLEAN)
    .addPrimaryKey(['id'],true)
    .addNullable(['member_id'])
    .addNullable(['date']);

// schemaBuilder.createTable(tableNames.setting)
//     .addColumn('language', lf.Type.INTEGER)

// if(localStorage.initDataHadInserted){
//     return;
// }else{

// }


schemaBuilder.connect().then(function(db) {
    thanksLogDB = db;

    //初期データ投入に関しては、localstrageに値を持たせるので解決させる。
    //最初falseにしておいて、データ投入後trueにする。

    if(localStorage.initDataHadInserted){
        return;
    }

    const membersTable = thanksLogDB.getSchema().table(tableNames.members);

    const firstMember = membersTable.createRow({
        name: 'あなた',
        memo:'このアプリを使ってくれるすばらしい人',
        head: 'basic',
        eyes: 'basic',
        eyeblows: 'basic',
        mouth: 'basic',
        face_ex: '',
        color:'hsl(6,77%,64%)',
        order:null,
        twitter_id:''
    });

    //クエリ
    const queryCreateFirstMember = thanksLogDB.insertOrReplace().into(membersTable).values([firstMember]);
    //クエリ実行
    return queryCreateFirstMember.exec();

}).then((result) => {        
    if(result === undefined){
        return;
    }
    
    //登録したメンバーを受けて、初期ありがとを登録
    const thanksTable = thanksLogDB.getSchema().table(tableNames.thanks);

    const firstThank = thanksTable.createRow({
        title: 'このアプリに気づいてくれた！',
        member_id:result[0].id,
        date:moment().format('YYYYMMDD'),
        memo:'使ってくれてありがとうございます！ありがとうと感じたらぜひ記録して活用してみてください！ご意見ご感想、ご要望もお待ちしています！',
        check:true,
    });

    const queryCreateFirstThank = thanksLogDB.insertOrReplace().into(thanksTable).values([firstThank]);

    return queryCreateFirstThank.exec().then(() => {
        localStorage.initDataHadInserted = true;        
    });
});


// schemaBuilder.connect().then(function(db) {
//     thanksLogDB = db;
// })
